/**
 * Authentication Token Interceptor (Functional) — cookie-session model
 *
 * Historically this interceptor attached a Bearer token from
 * GlobalAuthStateService and attempted MSAL silent-refresh on 401. Under the
 * cookie-session model (design.md Decision 1) that is gone:
 *
 * - The GTLC backend session lives in the httpOnly `gtlc_parent_session`
 *   cookie, attached automatically via `withCredentials: true` in
 *   `api.service.ts`. No Authorization header is set for any request.
 * - There is no client-side token to refresh. A 401 simply means "no valid
 *   backend session"; the app's auth state is corrected by the next
 *   `GET /parent-auth/whoami` (AuthService.checkInitialAuthState).
 *
 * Retained as a pass-through so the interceptor chain in `app.config.ts`
 * stays stable; it must NOT attach any header.
 */
import { HttpInterceptorFn } from '@angular/common/http';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => next(req);